module.exports = __webpack_public_path__ + "img/complete-requests.f5ea8cb4.svg";